export const slimeAttack = new Image();
slimeAttack.src = "./assets/characterSprites/slime/SlimeSheet.png";
slimeAttack.width = 256 / 8
slimeAttack.height = 75 / 3
slimeAttack.yOffset = 117.5
slimeAttack.xOffset = 195
slimeAttack.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];